// extracted by mini-css-extract-plugin
module.exports = {"container":"segmentControl__container___3OLBv","with-padding":"segmentControl__with-padding___2PmXr"};